import React, { useState, useEffect } from "react";
import { Box, Typography, CircularProgress, Button, Divider, Paper, TextField, useMediaQuery, FormControlLabel, RadioGroup, Radio } from "@mui/material";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import EditSquareIcon from "@mui/icons-material/EditSquare";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { usePTagForm } from "../contexts/PTagFormContext";
import { submitOrder } from "../services/orderService";
import { useTranslation } from "react-i18next";

export default function PTagAirPreview() {
  const navigate = useNavigate();
  const { form, setForm } = usePTagForm();
  const [loading, setLoading] = React.useState(false);
  const shipping = 50;
  const isMobile = useMediaQuery("(max-width:900px)");
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
    
  }, []);


  const handleSubmit = async () => {
    setLoading(true);
    try {
      const { temp_id } = await submitOrder(form);
      setForm((prev) => ({ ...prev, temp_id }));
      navigate("/ptag-air/confirmation");
    } catch (e) {
      alert("提交失敗，請稍後再試");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{ background: "#FCF8F3", minHeight: "100vh", pt: 10, position: "relative", }}
    >
      <Navbar />
      <Button
        sx={{ color: "black", minWidth: 0, position: "absolute", left: isMobile ? 10 : 80 }}
        onClick={() => navigate("/ptag-air/payment")}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="24" viewBox="0 0 14 24" fill="none">
          <path d="M12 22L2 12L12 2" stroke="#050505" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </Button>
      <Box
        sx={{
          maxWidth: 1080,
          width: "100%",
          mx: "auto",
          px: { xs: 1, sm: 2 },
          pt: { xs: 2, md: 6 },
          pb: { xs: 4, md: 8 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "flex-start",
            gap: { xs: 4, md: 6 },
            width: "100%",
          }}
        >
          {/* Left: Order Summary */}
          <Box sx={{ flex: 1, minWidth: 0, mb: { xs: 4, md: 0 }, mt: 4, px: 1 }}>
            <Paper elevation={0} sx={{ background: "transparent", p: 0 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <img
                  src="/icons/ptagair-2.png"
                  alt="PTag Air"
                  style={{
                    width: 150,
                    height: 150,
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
                <Box sx={{ display: "flex", alignItems: "flex-start", gap: isMobile ? 5 : 16 }}>
                  <Box>
                    <Typography fontWeight={700}>
                      PTag <span style={{ color: "#2196f3" }}>Air</span>
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                        <g clip-path="url(#clip0_5995_46606)">
                          <path d="M13.5801 6.84285V7.41075C13.5793 8.74187 13.1483 10.0371 12.3512 11.1032C11.5542 12.1694 10.4339 12.9493 9.15744 13.3267C7.88094 13.7042 6.51663 13.6588 5.268 13.1975C4.01936 12.7362 2.9533 11.8836 2.2288 10.767C1.50429 9.65027 1.16017 8.32931 1.24776 7.00107C1.33534 5.67282 1.84993 4.40848 2.71479 3.3966C3.57965 2.38471 4.74844 1.6795 6.04684 1.38615C7.34524 1.09279 8.70368 1.22701 9.91956 1.76877" stroke="#969696" stroke-width="1.23457" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M13.5794 2.46875L7.40654 8.64776L5.55469 6.79591" stroke="#969696" stroke-width="1.23457" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_5995_46606">
                            <rect width="14.8148" height="14.8148" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <Typography fontSize={14} color="text.secondary">
                        {t('white')}
                      </Typography>
                    </Box>
                  </Box>
                  <Box>
                    <Typography>
                      HKD $199
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <>
                {/* Price Summary */}
                <Box sx={{ mt: 4 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 1,
                    }}
                  >
                    <Typography color="text.secondary">{t('subtotal')}</Typography>
                    <Typography>HKD ${form.price}</Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 1,
                    }}
                  >
                    <Typography color="text.secondary">{t('shippingFee')}</Typography>
                    <Typography>HKD ${shipping}</Typography>
                  </Box>
                  <Divider sx={{ my: 1 }} />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography fontWeight={700}>{t('total')}</Typography>
                    <Typography fontWeight={700} fontSize={20} color="#050505">
                      HKD ${form.price + shipping}
                    </Typography>
                  </Box>
                </Box>
              </>
            </Paper>
          </Box>
          {/* Vertical Divider for desktop only */}
          <Divider
            orientation="vertical"
            flexItem
            sx={{ display: { xs: "none", md: "block" }, mx: 3, minHeight: 400 }}
          />
          {/* Horizontal divider for mobile only */}
          <Divider
            orientation="horizontal"
            flexItem
            sx={{ display: { xs: "block", md: "none" } }}
          />
          {/* Right: Preview Info */}
          <Box
            sx={{ flex: 1, minWidth: 0, width: "100%", mt: { xs: 4, md: 0 }, px: 1 }}
          >
            <Paper elevation={0} sx={{ background: "transparent", p: 0 }}>
              {/* Product Options */}
              {/* <Box mb={4}>
                <div className="flex items-center gap-2 mb-4">
                  <div className="text-2xl font-bold mb-2">覆核訂單</div>
                </div>
                <Typography fontWeight={700} fontSize={18} mb={2}>
                  PTag Air 款式
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Typography>版本: 普通版 HKD $199</Typography>
                  <Typography>尺寸: 30 毫米</Typography>
                  <Typography>顏色: 白色</Typography>
                </Box>
              </Box> */}

              {/* Conditionally show 打印內容 if version is custom */}
              <Box mb={4}>
                <Typography fontWeight={700} fontSize={18} mb={2}>
                  {t('PtagAirPrintContent')}
                </Typography>
                <Typography>{t('petName')}</Typography>
                <TextField
                  fullWidth
                  sx={{ my: 2 }}
                  value={form.petName || ""}
                  style={{ background: "#fff" }}
                />
                <Box sx={{ mb: 2, mt: 2 }}>
                  <Typography fontSize={15} mb={1} style={{ display: "flex", gap: 5 }}>
                    {t('photo')}
                  </Typography>
                  {form.photo ? (
                    <img
                      src={
                        typeof form.photo === "string"
                          ? form.photo
                          : URL.createObjectURL(form.photo)
                      }
                      alt="pet"
                      style={{
                        width: "100%",
                        height: 300,
                        objectFit: "contain",
                        borderRadius: 8,
                        border: "30px solid white",
                        backgroundColor: "#fff"
                      }}
                    />
                  ) : (
                    <Box
                      sx={{
                        width: "100%",
                        height: isMobile ? 200 : 250,
                        background: "#fff",
                        border: "1px dashed #ccc",
                        borderRadius: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="73" height="69" viewBox="0 0 73 69" fill="none">
                        <ellipse cx="11.7839" cy="35.8738" rx="7.37667" ry="10.9231" transform="rotate(-29.3518 11.7839 35.8738)" fill="#D9D9D9" />
                        <ellipse cx="25.6509" cy="12.0045" rx="7.37667" ry="10.9231" transform="rotate(-9.72478 25.6509 12.0045)" fill="#D9D9D9" />
                        <ellipse cx="7.37667" cy="10.9231" rx="7.37667" ry="10.9231" transform="matrix(-0.871627 -0.49017 -0.49017 0.871627 72.9961 29.9688)" fill="#D9D9D9" />
                        <ellipse cx="7.37667" cy="10.9231" rx="7.37667" ry="10.9231" transform="matrix(-0.985631 -0.168916 -0.168916 0.985631 56.4648 2.48438)" fill="#D9D9D9" />
                        <path d="M36.1553 35.2969C40.7313 35.2969 44.5896 38.3576 45.8018 42.543L52.3516 53.1035C55.2902 57.8413 53.8323 64.0641 49.0947 67.0029C44.892 69.6098 39.5225 68.7546 36.3115 65.2217C33.1006 68.7543 27.7319 69.6095 23.5293 67.0029C18.7916 64.0642 17.333 57.8413 20.2715 53.1035L26.3027 43.3779C27.2159 38.7705 31.2798 35.2969 36.1553 35.2969Z" fill="#D9D9D9" />
                      </svg>
                    </Box>
                  )}
                </Box>
              </Box>

              {/* 收件資料 and 付款資料 */}
              <>
                <Box mb={4}>
                  <Typography fontWeight={700} fontSize={18} mb={2}>
                    {t('deliveryInfo')}
                  </Typography>
                  <Typography>{t('recipient')}</Typography>
                  <TextField
                    fullWidth
                    sx={{ my: 2 }}
                    value={form.lastName || ""}
                    style={{ background: "#fff" }}
                  />
                  <Typography>
                    {t('contactNumber')}
                  </Typography>
                  <TextField
                    fullWidth
                    sx={{ my: 2 }}
                    value={form.phoneNumber || ""}
                    style={{ background: "#fff" }}
                  />
                  <Typography>{t('email')}</Typography>
                  <TextField
                    fullWidth
                    sx={{ my: 2 }}
                    value={form.email || ""}
                    style={{ background: "#fff" }}
                  />
                  <Typography>
                    {t('deliveryMethod')}
                  </Typography>
                  <TextField
                    fullWidth
                    sx={{ my: 2 }} 
                    value={form.delivery === "SF-HOME-DELIVERY" ? t('Delivery') : t('Pickup')}
                    style={{ background: "#fff" }}
                  />
                  <Typography>
                    {t('address')}
                  </Typography>
                  {form.netCode ? (
                    <Box sx={{
                      padding: 1,
                      border: "1px solid #ccc",
                      borderRadius: 2,
                      backgroundColor: "white",
                      my: 2,
                    }}>
                      <div style={{ fontWeight: 700, fontSize: 20 }}>{form.serviceName}</div>
                      <div style={{ fontWeight: 400, fontSize: 12 }}>{form.shippingAddress}</div>
                    </Box>
                  ) : (
                    <TextField
                      fullWidth
                      sx={{ my: 2 }}
                      value={form.address || ""}
                      style={{ background: "#fff" }}
                    />
                  )}
                </Box>
                <Box mb={4}>
                  <Typography fontWeight={700} fontSize={18} mb={2}>
                    {t('paymentInfo')}
                  </Typography>
                  <Typography>
                    {t('paymentMethod')}:
                  </Typography>
                  <RadioGroup
                    row
                    value={form.paymentWay}
                  >
                    <FormControlLabel
                      value="FPS"
                      control={<Radio
                        sx={{
                          '&.Mui-checked': {
                            color: '#FFB60C', // Checked color
                          },
                        }} />}
                      label={t('fps')}
                    />
                    <FormControlLabel
                      value="BANK"
                      control={<Radio
                        sx={{
                          '&.Mui-checked': {
                            color: '#FFB60C', // Checked color
                          },
                        }} />}
                      label={t('bankTransfer')}
                    />
                  </RadioGroup>
                </Box>
                <Button
                  variant="contained"
                  sx={{
                    background: "#FFB60C",
                    color: "#050505",
                    fontWeight: 700,
                    fontSize: 16,
                    borderRadius: 2,
                    px: 6,
                    py: 1.5,
                    mt: 2,
                    boxShadow: "none",
                    "&:hover": { background: "#FFB60C" },
                    "&:disabled": { background: "rgba(255, 182, 12, 0.5)" },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                  }}
                  fullWidth
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  {t('submitOrder')}
                  {loading && (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                      }}
                    >
                      <CircularProgress size={20} color="inherit" />
                    </span>
                  )}
                </Button>
              </>
            </Paper>
          </Box>
        </Box>
      </Box>
      <Footer />
    </Box>
  );
}
